import React from 'react';
import { ListBackgroundColor, IListItemProps, EListBackgroundColor } from '@adac-mp/shared';
import { ListItem, TypographyColor, TypographyVariant } from '../../index';

interface IListProps {
	backgroundColor?: ListBackgroundColor;
	columnRow?: boolean;
	fullSpace?: boolean;
	items: IListItemProps[];
	labelVariant?: TypographyVariant;
	valueVariant?: TypographyVariant;
	valueColor?: TypographyColor;
	narrow?: boolean;
	noBorder?: boolean;
	singleItems?: boolean;
	wrapperClassName?: string;
}

export const List = ({
	backgroundColor = 'white',
	columnRow = false,
	items,
	fullSpace = false,
	labelVariant = 'abstract',
	valueVariant = 'abstract',
	valueColor = 'title',
	narrow = false,
	noBorder = false,
	singleItems = false,
	wrapperClassName = '',
}: IListProps) => {
	const listItems = items.map((item, index) =>
		item.type === 'separator' ? (
			<div
				key={index}
				className={`px-4 py-1.5 w-full ${
					item.isHighlighted ? 'bg-gray-600/[.4]' : `${EListBackgroundColor[backgroundColor]}`
				}`}>
				<hr className="bg-gray-500 h-px border-none" />
			</div>
		) : (
			<ListItem
				key={index}
				columnRow={columnRow}
				noBorder={noBorder}
				singleItem={singleItems}
				backgroundColor={backgroundColor}
				narrow={narrow}
				fullSpace={fullSpace}
				labelVariant={labelVariant}
				valueVariant={valueVariant}
				valueColor={valueColor}
				{...item}
			/>
		),
	);

	return (
		<ul
			className={`${
				!singleItems && `rounded-lg ${!noBorder && 'border-solid border-2 border-gray-600'}`
			} overflow-hidden ${wrapperClassName}`}>
			{listItems}
		</ul>
	);
};
